<template>
  <div>
    <h4 style="text-align: center;">历史记录</h4>
    <div class="block">
      <el-card class="history-list">
        <div class="history-record" v-for="(item, index) in recordList">
         <div v-html="item"></div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    recordList: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  async mounted() {
  },
}
</script>
<style>
.history-list{
  overflow-y: auto;
  max-height: 200px;
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}
.history-record{
  border-bottom: 2px solid #eee;
  padding: 20px 0;
  font-size: 14px;
  color: #606266;
}
.history-record p{
  line-height: 20px;
  margin: 0;
}
.history-list::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 16px;
}

.history-list::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
  rgba(255, 255, 255, 0.2) 25%,
  transparent 25%,
  transparent 50%,
  rgba(255, 255, 255, 0.2) 50%,
  rgba(255, 255, 255, 0.2) 75%,
  transparent 75%,
  transparent);
}

.history-list::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}
</style>